import React from "react";

const handleTransitOpenPayments = (props) => {
  const options = [
    {
      text: 'Qu\'est-ce que les paiements ouverts pour les transports en commun?',
      handler: props.actionProvider.handleTransit1,
      id: 1,
    },
    {
      text: 'Où puis-je utiliser ma carte de débit dans un système de paiements ouverts pour les transports en commun?',
      handler: props.actionProvider.handleTransit2,
      id: 2
    },
    {
      text: 'Les systèmes de paiement ouverts pour les transports en commun seront-ils offerts par les sociétés de transport de l\'ensemble des municipalités canadiennes?',
      handler: props.actionProvider.handleTransit3,
      id: 3
    },
    {
      text: 'Je possède une carte de paiement d\'une société de transport (comme une carte PRESTO). Le nouveau mode de paiement remplacera-t-il ce type de carte? ',
      handler: props.actionProvider.handleTransit4,
      id: 4
    },
    {
      text: 'Comment les frais me seront-ils facturés lorsque j\'utiliserai Débit INTERAC à bord de GO Transit et d\'UP Express?',
      handler: props.actionProvider.handleTransit5,
      id: 5
    },
    {
      text: 'Avec qui dois-je communiquer si j\'ai un problème avec un paiement effectué par Débit INTERAC sur un lecteur de titres? ',
      handler: props.actionProvider.handleTransit6,
      id: 6
    },
    {
      text: 'Comment puis-je payer mon titre par Débit INTERAC dans les transports en commun participants?',
      handler: props.actionProvider.handleTransit7,
      id: 7
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container transit-open-payments'>{optionsMarkup}</div>;
};

export default handleTransitOpenPayments;